import axios from "axios";
import { API } from "./utils";

export const CLIENT_TOKEN_KEY = "flow_client_token";

export const clientApi = axios.create({ baseURL: API });

clientApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(CLIENT_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
